import { useI18n } from 'vue-i18n';
import NavigationHelper from '@/util/NavigationHelper';
import { useRouter } from 'vue-router';
import { Forms } from '@/enums/Forms';
import UserController from '@/controllers/UserController';
import ValidationRules from '@/util/ValidationRules';
import { Ref, ref } from 'vue';
import PageHelper from '@/util/PageHelper';
import PolteqButton from '@/components/PolteqButton/PolteqButton.vue';
import PolteqTextField from '@/components/PolteqTextField/PolteqTextField.vue';
import { VForm } from 'vuetify/components';

export default {
  name: 'ResetPasswordForm',
  components: {
    PolteqButton,
    PolteqTextField
  },
  computed: {
    NavigationHelper() {
      return NavigationHelper;
    }
  },
  setup() {
    const i18n = useI18n();
    const router = useRouter();
    const location = window.location.search;
    const code = new URLSearchParams(location).get('resetCode');
    const rules = ValidationRules.getRules();
    const resetPasswordForm = ref() as Ref<VForm>;
    const resetPassword = async (email: string, code: string, newpassword: string) => {
      await resetPasswordForm.value.validate();
      if (resetPasswordForm.value.isValid) {
        const response = await UserController.resetPassword(email, code, newpassword);
        PageHelper.setNotificationMessage(response);
        await NavigationHelper.openForm(router, Forms.SIGN_IN);
      }
    };
    return {
      i18n,
      router,
      Forms,
      code,
      rules,
      resetPasswordForm,
      resetPassword
    };
  },
  data() {
    return {
      email: '',
      newpassword: '',
      confirmpassword: ''
    };
  }
};
